exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".js-show-child-nav {\r\n    cursor: pointer;\r\n}\r\n\r\n.an-arrow-nav.active {\r\n    transform: rotateX(-180deg);\r\n}\r\n\r\n.js-open-nav.active {\r\n    display: block;\r\n}\r\n\r\nul.active {\r\n    display: block;\r\n}\r\n\r\na.active {\r\n    background: #9c1533;\r\n    color: white;\r\n}\r\n\r\nspan.bmi-icon-dot {\r\n    position: absolute;\r\n    width: 8px;\r\n    height: 8px;\r\n    background: #70c1b3;\r\n    left: 24px;\r\n    top: 10px;\r\n    border-radius: 50%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/sidebar/sidebar.component.css
// module id = ../../../../../src/app/shared/sidebar/sidebar.component.css
// module chunks = main